export default __webpack_public_path__ + "static/media/forestly-expl-dissect-intro_EN.f577e5a1.png";